import React, { useState } from 'react';
import './Navbar.css';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMenuItemClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <a href="/">
            <img src="/logo.png" alt="Safal Bharat logo" className="logo-image" />
          </a>
        </div>

        <ul className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <li className="navbar-item">
            <a href="/" className="navbar-link" onClick={handleMenuItemClick}>Home</a>
          </li>
          <li className="navbar-item">
            <a href="#about" className="navbar-link" onClick={handleMenuItemClick}>About</a>
          </li>
          <li className="navbar-item">
            <a href="#services" className="navbar-link" onClick={handleMenuItemClick}>Services</a>
          </li>
          <li className="navbar-item">
            <a href="#contact-form" className="navbar-link" onClick={handleMenuItemClick}>Contact</a>
          </li>
        </ul>

        <div className="navbar-buttons-group">
          <button className="hamburger" onClick={toggleMenu} aria-label="Toggle menu">
            <span className={`hamburger-line ${isMenuOpen ? 'active' : ''}`}></span>
            <span className={`hamburger-line ${isMenuOpen ? 'active' : ''}`}></span>
            <span className={`hamburger-line ${isMenuOpen ? 'active' : ''}`}></span>
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
